import * as eventCategories from './constants/eventCategories';
import * as eventNames from './constants/eventNames';

export const recordWebVitalsEvent = (
  id: string,
  name: string,
  value: number,
  source: string,
) => {
  return {
    event: eventNames.WEB_VITALS,
    category: eventCategories.WEB_VITALS,
    source: source,
    action: name,
    // Google Analytics metrics must be integers, so the value is rounded.
    // For CLS the value is first multiplied by 1000 for greater precision
    // (note: increase the multiplier for greater precision if needed).
    value: Math.round(name === 'CLS' ? value * 1000 : value),
    // The `id` value will be unique to the current page load. When sending
    // multiple values from the same page (e.g. for CLS), Google Analytics can
    // compute a total by grouping on this ID (note: requires `eventLabel` to
    // be a dimension in your report).
    label: id,
  };
};
